module.exports = __webpack_public_path__ + "img/cisco.ff071c24.png";